var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-error-layout--container"},[_c('div',[_c('div',{staticClass:"camera-error-layout--header"},[_vm._t("header")],2),_c('div',{staticClass:"camera-error-layout--content"},[_vm._t("content")],2)]),_c('div',{staticClass:"camera-error-layout--footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }